import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// Mark that React has loaded
window.__REACT_LOADED__ = true;

const rootElement = document.getElementById("root");

// Remove SEO fallback content and styles
const seoFallback = document.getElementById("seo-fallback");
if (seoFallback) {
  seoFallback.remove();
}

const seoStyles = document.getElementById("seo-styles");
if (seoStyles) {
  seoStyles.remove();
}

const seoLoader = document.getElementById("seo-loader");
if (seoLoader) {
  seoLoader.remove();
}

// Render React app
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
